import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, subtitle, testid }) => (
  <section className="bg-[#0F4C2A] diagonal-stripes text-white" data-testid={testid}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
        <span className="block text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#F59E0B] mb-3">{eyebrow}</span>
        <h1 className="font-condensed text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-none">{title}</h1>
        {subtitle && <p className="mt-4 max-w-2xl text-sm sm:text-base text-white/80 leading-relaxed">{subtitle}</p>}
      </motion.div>
    </div>
  </section>
);
